// HelperService.js
import axios from 'axios';
import { refreshAccessToken, handleLogout } from './userService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5000';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

const authEndpoints = [
  '/auth/login',
  '/auth/register',
  '/auth/confirm_registration',
  '/auth/confirm-email',
  '/auth/request_password_reset',
  '/auth/reset_password_with_code'
];

// Request interceptor to add Authorization header from localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    if (authEndpoints.some((endpoint) => config.url?.startsWith(endpoint))) {
      return config;
    }

    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    console.error('Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// HelperService.js

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401, not retried yet, and not for /auth/refresh
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== '/auth/refresh' &&
      !authEndpoints.some((endpoint) => originalRequest.url?.startsWith(endpoint))
    ) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        handleLogout();
        return Promise.reject(error);
      }

      try {
        const newAccessToken = await refreshAccessToken(refreshToken);
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        handleLogout();
        return Promise.reject(refreshError);
      }
    }

    // If the error is not 401 or the request is to /auth/refresh, reject the promise
    return Promise.reject(error);
  }
);


export { axiosInstance };
